import React from 'react'
import Application from './Application'
import Dashboard from './app/dashboard/components/Dashboard'

const App = () => {
  return (
    <div>
      <Application/>
    </div>
  )
}

export default App